// DESCRIPTION: Debounced search input for filtering events
// by title or content in the frontend display.

import { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';

const SearchInput = ( { onSearch } ) => {
	const [ inputValue, setInputValue ] = useState( '' );

	useEffect( () => {
		const timer = setTimeout( () => {
			onSearch( inputValue );
		}, 300 );

		return () => clearTimeout( timer );
	}, [ inputValue ] );

	return (
		<div className="nb-relative nb-flex-1 nb-max-w-sm">
			<div className="nb-absolute nb-inset-y-0 nb-left-0 nb-pl-3 nb-flex nb-items-center nb-pointer-events-none">
				<svg
					className="nb-w-4 nb-h-4 nb-text-gray-400"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={ 2 }
						d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
					/>
				</svg>
			</div>
			<input
				type="text"
				className="nb-block nb-w-full nb-pl-10 nb-pr-3 nb-py-2 nb-border nb-border-slate-200 nb-rounded-lg nb-text-sm nb-placeholder-gray-400 focus:nb-outline-none focus:nb-ring-2 focus:nb-ring-slate-500 focus:nb-border-slate-500 nb-transition-all nb-duration-200"
				placeholder={ __( 'Search events\u2026', 'nemtly-booking' ) }
				value={ inputValue }
				onChange={ ( e ) => setInputValue( e.target.value ) }
			/>
		</div>
	);
};

export default SearchInput;
